import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { NeonButton } from "@/components/Buttons";
import { scrollToId } from "@/lib/ui";

const LINES = [
  { text: "STOP CHASING PREDICTIONS.", tone: "text-dim" },
  { text: "BUILD A PROCESS.", tone: "text-mist" },
  { text: "FOLLOW THE PROCESS.", tone: "text-mist" },
  { text: "MEASURE THE PROCESS.", tone: "text-mist" },
  { text: "MASTER EXECUTION.", tone: "text-neon" },
];

export default function FinalCTA() {
  return (
    <section
      data-testid="final-cta-section"
      className="relative overflow-hidden py-28 text-center lg:py-40"
    >
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-[520px] w-[820px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-neon/[0.05] blur-[160px]" />

      <div className="relative mx-auto max-w-4xl px-4 sm:px-6">
        <Reveal>
          <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-dim">
            You don't need another strategy.
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-display text-6xl font-extrabold uppercase leading-[1.0] tracking-tight text-white sm:text-8xl">
            Become
            <br />
            the <span className="glow-text-neon text-neon">Executor.</span>
          </h2>
        </Reveal>

        <div className="mt-12 space-y-2.5">
          {LINES.map((l, i) => (
            <Reveal key={l.text} delay={0.2 + 0.09 * i}>
              <div className={`font-mono text-xs uppercase tracking-[0.3em] sm:text-sm ${l.tone}`}>
                {l.text}
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.6}>
          <NeonButton
            testid="final-cta-button"
            onClick={() => scrollToId("pricing")}
            className="mt-14 px-10 py-4 text-base"
          >
            Join Execution Traders
            <ArrowRight size={18} />
          </NeonButton>
        </Reveal>

        <Reveal delay={0.7}>
          <div className="mt-16">
            <div className="font-display text-2xl font-extrabold tracking-tight text-white">
              P.E.E. OS™
            </div>
            <div className="mt-3 font-mono text-[10px] uppercase tracking-[0.3em] text-dim">
              Position • Event • Entry
            </div>
            <div className="mt-1.5 font-mono text-[10px] uppercase tracking-[0.3em] text-neon/80">
              Execution Over Everything.
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
